
import { Placement } from '@post-office/placements-frontend/atlas-home-for-you-main-content';
export default Placement;
